import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TipsPerTransportType from "@SearchResults/features/staticContent/components/TipsPerTransportType";

function TrainTipsContent() {
    const title = useTranslation(`${singleModalTranslationKey}.trains.title`)
    const {
        title: subtitle,
        o1,
        o2,
        o3,
        o4,
        o5,
    } = useTranslation(`${singleModalTranslationKey}.trains.tips`)

    return (
        <TipsPerTransportType
            title={title}
            subtitle={subtitle}
            options={[
                {id: "train-o1", option: o1},
                {id: "train-o2", option: o2},
                {id: "train-o3", option: o3},
                {id: "train-o4", option: o4},
                {id: "train-o5", option: o5},
            ]}
        />
    );
}

export default TrainTipsContent